// react and mui stuff
import { useState } from "react"

import Table from "@mui/joy/Table"
import Button from "@mui/joy/Button";
import Checkbox from "@mui/joy/Checkbox";

// custom components
import UserCard from "../../components/usercard";
import { FetchButton, ReportProps } from "./utils";

// data and stuff
import { RankReport } from "../../types/reports";
import { reportAPI } from "../../utils/backend"
import { setData } from "../../utils/setdata";

const rankenum: Record<number, string> = {
  0: "No Rank",
  10: "Novice",
  30: "Veteran",
  50: "Hero",
  80: "Legend",
  90: "Ancient"
}

export default function RankErrorsReport({report, setReport, setToast, setUser, user}: ReportProps<RankReport[]>) {
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState<string[]>([])

  function fixRanks() {
    if (selected.length === 0) return;
    setLoading(true)
    reportAPI.fixRanks(selected).then(info => {
      const onFinish = () => {
        setLoading(false);
        setSelected([]);
      }

      if (!setData(info, setToast, user, setUser, onFinish)) return;      
      setReport(info)
      onFinish();
    })
  }

  return (
    <div>
      {!report &&
        <FetchButton
          user={user}
          apiFunction={reportAPI.getRanks}
          loading={loading}
          setLoading={setLoading}
          setReport={setReport}
          setToast={setToast}
          setUser={setUser}
        />
      }
      {report &&
        <>
          <Button
            disabled={selected.length === 0}
            loading={loading}
            onClick={() => {
              if (!loading) fixRanks()
            }}
          >
            Update Selected
          </Button>
          <br/>
          <Table>
            <thead>
              <tr>
                <th style={{ width: "50px" }}>
                  <Checkbox
                    checked={selected.length === report.length}
                    onChange={() => {
                      if (selected.length === report.length) setSelected([])
                      else setSelected(report.map(r => r.id))
                    }}
                  />
                </th>
                <th>User</th>
                <th>Current Rank</th>
                <th>Expected Rank</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {report.map(usr => (
                <tr>
                  <td>
                    <Checkbox
                      checked={selected.includes(usr.id)}
                      onChange={() => {
                        if (selected.includes(usr.id)) setSelected(selected.filter(r => r !== usr.id))
                        else setSelected([...selected, usr.id])
                      }}
                    />
                  </td>
                  <td><UserCard profile={usr} loading={false}/></td>
                  <td>{rankenum[usr.actualRank]}</td>
                  <td>{rankenum[usr.expectedRank]}</td>
                  <td>{usr.expectedRank > usr.actualRank ? "Upgrade" : "Downgrade"}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      }
    </div>
  )
}